import React, { createContext, useState } from "react";

export const ActionContext = createContext();

export const ActionProvider = ({ children }) => {
  const [actions, setActions] = useState([
    {
    id: 1,
    name: "Yeni Servis",
    subActions: [1,2,3],
  },
  {
    id: 2,
    name: "Servis Sonlandırıldı",
    subActions: [4,7,5,6],
  },
  {
    id: 3,
    name: "Yerinde Bakım Yapıldı",
    subActions: [8,9,10],
  },
  {
    id: 4,
    name: "Teknisyen Yönlendir",
    subActions: [10,11,2,7,12,13,14,15,3,5,16],
  },
  {
    id: 5,
    name: "Tahsilata Gönder",
    subActions: [8],
  },
  {
    id: 6,
    name: "Fiyatta Anlaşılamadı",
    subActions: [7],
  },
  {
    id: 7,
    name: "Teyid Araması",
    subActions: [],
  },
  {
    id: 8,
    name: "Yeniden Teknisyen Yönlendir",
    subActions: [3,7],
  },
  {
    id: 9,
    name: "Müşteriye Ulaşılamadı",
    subActions: [12],
  },
  {
    id: 10,
    name: "Haber Verecek",
    subActions: [7],
  },
  {
    id: 11,
    name: "Parçası Atölyeye Alındı",
    subActions: [1],
  },
  {
    id: 12,
    name: "Atölyeye Alındı",
    subActions: [1,5,3],
  },
  {
    id: 13,
    name: "Parça Gidecek",
    subActions: [1,14,3], 
  },
  {
    id: 14,
    name: "Müşteri İptal Etti",
    subActions: [7],
  },
  {
    id: 15,
    name: "Cihaz Teslim Edildi",
    subActions: [8],
  },
  {
    id: 16,
    name: "Cihaz Tamir Edilemiyor",
    subActions: [],
  },
  {
    id: 17,
    name: "Şikayetçi",
    subActions: [1,3],
  },
  ]);

  // Yeni aksiyon ekleme
  const addAction = (name, subActions = []) => {
    const newAction = {
      id: actions.length + 1,
      name,
      subActions,
    };
    setActions((prev) => [...prev, newAction]);
  };

  // Aksiyon güncelleme
  const updateAction = (id, newName, newSubActions) => {
    setActions((prev) =>
      prev.map((a) =>
        a.id === id
          ? { ...a, name: newName ?? a.name, subActions: newSubActions ?? a.subActions }
          : a
      )
    );
  };

  // Aksiyon silme
  const deleteAction = (id) => {
    setActions((prev) => prev.filter((a) => a.id !== id));
  };

  return (
    <ActionContext.Provider
      value={{ actions, addAction, updateAction, deleteAction }}
    >
      {children}
    </ActionContext.Provider>
  );
};
